import { useApi } from '../../hooks/storeHook'
import { integrationTypeNames, StoreIntegrationType } from '../../types/integrationTypeUtils'
import { Info } from '@material-ui/icons'
import React from 'react'
import { CommissionsButtonBase } from './CommissionsButtonBase'

export type CommissionsTypeProps = {
  type: StoreIntegrationType

  accountId: number
}

export type CommissionsExtraIdProps = {
  orderId: number
}

export type CommissionsButtonProps =
  CommissionsTypeProps
  & CommissionsExtraIdProps
  & CommissionsIconProps

export const CommissionsButton =
  ({type, themed, accountId, orderId}: CommissionsButtonProps) => {
    const api = useApi()

    const loadOrderCommissions =
      async () => {
        if (orderId <= 0) {
          throw new Error('orderId must be positive')
        }

        return await api.userSync.getOrderCommissions(type, accountId, orderId)
      }

    return (
      <CommissionsButtonBase
        title={`${integrationTypeNames[type]} #${orderId}`}
        icon={<CommissionsIcon themed={themed}/>}
        loadOrderCommissions={loadOrderCommissions}
      />
    )
  }

export type CommissionsIconProps = {
  themed?: boolean
}

const CommissionsIcon =
  ({themed}: CommissionsIconProps) =>
    <Info
      fontSize="small"
      color={themed ? undefined : 'action'}
      htmlColor={themed ? '#3987CF' : undefined}
    />